import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import GenericOverviewInfo from 'scoreboard/components/overview-info/generic-overview-info'
import basicInfoLinkedItem from 'scoreboard/components/overview-info/basic-info-linked-item.hbs'

/**
 * A Generic Overview Info dialog view with added report dataset information.
 */
var ReportDatasetOverviewInfo = GenericOverviewInfo.extend({
	render() {
		GenericOverviewInfo.prototype.render.apply(this, arguments)

		// Insert the source dataset label so we can navigate to it easily #37592
		this.$('.basic-info .list').prepend(basicInfoLinkedItem({
			label: i18n.get('scorecards.node.source.withArg', 'datasets.dataset'),
			href: `/datasets/${_.get(this.model.attributes, 'dataset.id')}`,
			itemLabel: _.get(this.model, 'datasetLabel')
		}))
		return this
	}
})


export default ReportDatasetOverviewInfo

ReportDatasetOverviewInfo.__filename__ = 'reports/report-dataset-overview-info.js'
